import React from 'react';
import '../../CustomModule.css';
import { getControlStyle, imageUrl } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function Signature({
  digitalSignPath,
  fontFamily,
  label,
  placeholder,
  fromForm,
  duplicatingItem,
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const filePreview = () => {
    return digitalSignPath
      ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${digitalSignPath}`)
      : '';
  };
  let logo = null;
  if (digitalSignPath.includes('base64')) {
    logo = digitalSignPath;
  } else {
    logo = `${imageUrl}/${digitalSignPath}`;
  }
  const combinedStyles = getControlStyle(otherConfiguration);

  return (
    <div className="position-relative">
      <p className={`text-left mb-1 fs-custom-module ${boldLabel && 'font-weight-bold'}`}>{label}</p>
      <div style={combinedStyles}>
        {digitalSignPath !== '' ? (
          <img src={digitalSignPath.includes('base64') ? logo : filePreview()} className="signature-image" alt="" />
        ) : (
          <p className="h4 mb-0 px-2" style={{ fontFamily }}>
            {placeholder}
          </p>
        )}
      </div>

      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}
export default Signature;
